import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faSortAmountDownAlt, faSortAmountUp } from '@fortawesome/pro-light-svg-icons';

import theme from './OrderListItem.module.scss';
import { Trans } from '@lingui/react/macro';
import { Dropdown, DropdownButton } from '@ygtechnologies/rubus-ui';

export const OrderSortingDropdown = ({ currentSortDefinition, sortDefinitions, currentSort, setCurrentSort }) => {
    return (
        <>
            <div className={theme.separatorDiv}>
                <span className={theme.separator}></span>
            </div>
            <DropdownButton
                variant="tertiary"
                className={theme.defaultDropdown}
                label={
                    <div className={theme.sortBy}>
                        <span>
                            <Trans>Sort by</Trans>
                        </span>{' '}
                        {currentSortDefinition?.labelGenerator()}{' '}
                        {currentSort?.direction === 'desc' ? (
                            <FontAwesomeIcon icon={faSortAmountDownAlt} />
                        ) : (
                            <FontAwesomeIcon icon={faSortAmountUp} />
                        )}
                        <FontAwesomeIcon icon={faChevronDown} />
                    </div>
                }>
                {sortDefinitions.map((sort) => (
                    <React.Fragment key={sort.id}>
                        <Dropdown.Item onClick={() => setCurrentSort({ id: sort.id, direction: 'asc' })}>
                            {sort.labelGenerator()} (<Trans>Ascending</Trans>)
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => setCurrentSort({ id: sort.id, direction: 'desc' })}>
                            {sort.labelGenerator()} (<Trans>Descending</Trans>)
                        </Dropdown.Item>
                    </React.Fragment>
                ))}
            </DropdownButton>
        </>
    );
};
